var React = require('react');

function JkLogoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37.5,0.00686509329 L74.9644488,37.5007439 L37.5,74.9946227 L0.0355512323,37.5007439 L37.5,0.00686509329 Z M41.9152276,32.4037706 L33.0847724,32.4037706 L33.0847724,58.9159466 C35.6160258,58.8380931 37.697751,57.9751948 39.329948,56.3272518 C40.962145,54.6793088 41.8239049,52.5963683 41.9152276,50.0784305 L41.9152276,50.0784305 L41.9152276,32.4037706 Z M41.9152276,17.674784 L33.0847724,17.674784 L33.0847724,26.512176 L41.9152276,17.674784 Z","id":"Combined-Shape"}));
}

JkLogoInline.defaultProps = {"width":"75px","height":"75px","viewBox":"0 0 75 75","version":"1.1"};

module.exports = JkLogoInline;

JkLogoInline.default = JkLogoInline;
